import { Paper, Typography, Box, Grid, CircularProgress } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import Hint from '../Crosspage/Hint';
import IntroChoice from './IntroChoice';


export default function Intro(props) {

    const navigate = useNavigate();

    const {t} = useTranslation()

    const hint =             
    <Paper sx={{maxWidth: 800, p: 2, m: 1}}>
        <Typography align="left" sx={{mb: 1}}>
            {t("welcome", {"website": "Gekonnt hanDeln"})}
        </Typography>
        <Typography align="left">
            {t("comicHint")}
        </Typography>
    </Paper>
    
    const moveToStory = (storyId) => {
        navigate("/story/" + storyId);
    }

    if (!props.characterStories || !props.choices) return <CircularProgress />

    const renderButtons = () => {

        const charButtons = [];

        for (let char of props.characters) {
            let storyId = getStoryId(char.id);
            let choice = props.choices.find(value => 
                value.relevant && value.substoryId === storyId
            )
            if (!choice) return null;
            let n_choices = choice.answers.length
            charButtons.push(
                <Grid item xs={12} md={6} key={char.id}>
                    <IntroChoice 
                            image={char.imgSrc} imageDescription={char.name} 
                            buttonText={char.welcomeText}
                            moveToStory={() => moveToStory(storyId)}
                            storyProgress={props.storyProgress.find(val => val.storyId === storyId)}
                            n_choices={n_choices}
                    />
                </Grid>
            )
        }

        return charButtons
    }

    const getStoryId = (charId) => {
        const characterStory = props.characterStories.find(val => val.characterId === charId);
        let storyId = ""
        if (characterStory) {
            storyId = characterStory.storyId;
        }
        return storyId;
    }

    return(
        <Box
            sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center"
            }}
        >   
            <Paper sx={{p: 2, m: 2}}>
                <Typography variant="h1" sx={{mb: 0}}>{t("comicsHeader")}</Typography>
            </Paper>
            {
                !props.seenStoryHint &&
                <Hint handleHintClosed={props.setStoryHintSeen} hint={hint}/>
            }
            <Paper elevation={1}
                sx={{
                flexGrow: 1,
                maxWidth: 800,
                // mt: 0,
                m: {xs: 1, sm: 2, md: 3},
                p: {xs: 1, sm: 2, md: 3},

            }}
            >
                <Grid container spacing={4}>
                    {renderButtons()}
                </Grid>
            </Paper>

        </Box>
    );
}